import React from 'react';
import { MonoTag } from '../shared';
import Checkbox from '../../../../components/Checkbox';
import { colors } from '../../../../colors';
import { INFO_CARDS } from '../data';

const Information: React.FC<{
  emailsEnabled: boolean;
  onToggleEmails: (v: boolean) => void;
  phone?: boolean;
  narrow?: boolean;
  tabletRail?: boolean;
}> = ({ emailsEnabled, onToggleEmails, phone, narrow, tabletRail }) => (
  <div
    style={{
      padding: phone ? '28px 20px 20px' : '48px 56px',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: 26,
      minHeight: 0,
    }}
  >
    <div>
      <h1
        style={{
          margin: '0 0 12px 0',
          fontSize: phone ? 34 : 56,
          fontWeight: 600,
          lineHeight: 0.95,
          letterSpacing: '-.01em',
        }}
      >
        A few things before launch.
      </h1>
      <p
        style={{
          margin: 0,
          fontSize: 15,
          color: '#9a9a9a',
          maxWidth: 580,
          lineHeight: 1.6,
        }}
      >
        Three operational concepts to internalize: credits, exchange
        permissions, and what pausing a subscription actually does.
      </p>
    </div>
    <div
      className="no-scrollbar"
      style={{
        flex: narrow ? '0 0 auto' : 1,
        display: 'flex',
        alignItems: 'flex-start',
        minHeight: 0,
        marginTop: narrow ? 12 : 32,
        overflowY: phone ? 'visible' : 'auto',
        scrollbarWidth: 'none',
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: narrow ? '1fr' : 'repeat(3, 1fr)',
          gap: narrow ? 20 : 32,
        }}
      >
        {INFO_CARDS.map((c) => (
          <div
            key={c.n}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              borderTop: '2px solid #00B061',
              paddingTop: 20,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
              <MonoTag color="#00B061">{c.n}</MonoTag>
              <div
                style={{
                  fontSize: tabletRail ? 18 : 22,
                  fontWeight: 600,
                  letterSpacing: '-.005em',
                }}
              >
                {c.k}
              </div>
            </div>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                color: '#9a9a9a',
                lineHeight: 1.65,
              }}
            >
              {c.body}
            </p>
          </div>
        ))}
      </div>
    </div>
    <div
      style={{ paddingTop: 8, display: 'flex', alignItems: 'center', gap: 14 }}
    >
      <Checkbox
        label="Receive an email on every transaction"
        value={emailsEnabled}
        handleValueChange={onToggleEmails}
        color={colors.orange}
        labelColor="white"
      />
      <MonoTag
        color="#787878"
        size={10}
        style={{ lineHeight: 1, marginTop: 3 }}
      >
        (can be toggled later in account)
      </MonoTag>
    </div>
  </div>
);

export default Information;
